import { render, staticRenderFns } from "./EditAddressModal.vue?vue&type=template&id=b1dc2fb2&"
import script from "./EditAddressModal.vue?vue&type=script&lang=ts&"
export * from "./EditAddressModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports